

const PURPOSES = {
    PURPOSE_FIX_HOUSE: {
        id: '21',
        icon: 'loan-purpose-house-fix',
        text: 'contractEasyLoanStepOne-purposeFixHouse',
        stepThreeTransKey: 'payrollLoanRequestStepThree-purposeFixHouse',
        payrollLoanRequestTransKey: 'contractLoanSuccess-purposeFixHouse',
        payrollLoanContractsTransKey: 'contractLoanSuccess-purposeFixHouseContracts',
        stepTwoTransKey: 'payrollLoanRequestStepTwo-purposeFixHouse',
    },
    PURPORSE_HOME_ELEMENTS: {
        id: '23',
        icon: 'loan-purpose-home-elements',
        text: 'contractEasyLoanStepOne-purposeHomeElements',
        stepThreeTransKey: 'payrollLoanRequestStepThree-purposeHomeElements',
        payrollLoanRequestTransKey: 'contractLoanSuccess-purposeHomeElements',
        payrollLoanContractsTransKey: 'contractLoanSuccess-purposeHomeElementsContracts',
        stepTwoTransKey: 'payrollLoanRequestStepTwo-purposeHomeElements',
    },
    PURPOSE_VEHICLE: {
        id: '22',
        icon: 'loan-purpose-vehicle',
        text: 'contractEasyLoanStepOne-purposeVehicle',
        stepThreeTransKey: 'payrollLoanRequestStepThree-purposeBuyVehicle',
        payrollLoanRequestTransKey: 'contractLoanSuccess-purposeBuyVehicle',
        payrollLoanContractsTransKey: 'contractLoanSuccess-purposeBuyVehicleContracts',
        stepTwoTransKey: 'payrollLoanRequestStepTwo-purposeBuyVehicle',
    },
    PURPOSE_TRAVEL: {
        id: '26',
        icon: 'loan-purpose-travel',
        text: 'contractEasyLoanStepOne-purposeTravel',
        stepThreeTransKey: 'payrollLoanRequestStepThree-purposeTravel',
        payrollLoanRequestTransKey: 'contractLoanSuccess-purposeTravel',
        payrollLoanContractsTransKey: 'contractLoanSuccess-purposeTravelContracts',
        stepTwoTransKey: 'payrollLoanRequestStepTwo-purposeTravel',
    },
    PURPOSE_HEALTH: {
        id: '25',
        icon: 'loan-purpose-healthcare',
        text: 'contractEasyLoanStepOne-purposeHealth',
        stepThreeTransKey: 'payrollLoanRequestStepThree-purposeHealth',
        payrollLoanRequestTransKey: 'contractLoanSuccess-purposeHealth',
        payrollLoanContractsTransKey: 'contractLoanSuccess-purposeHealthContracts',
        stepTwoTransKey: 'payrollLoanRequestStepTwo-purposeHealthContracts',
    },
    PURPOSE_STUDIES: {
        id: '24',
        icon: 'loan-purpose-studies',
        text: 'contractEasyLoanStepOne-purposeStudies',
        stepThreeTransKey: 'payrollLoanRequestStepThree-purposeStudies',
        payrollLoanRequestTransKey: 'contractLoanSuccess-purposeStudies',
        payrollLoanContractsTransKey: 'contractLoanSuccess-purposeStudiesContracts',
        stepTwoTransKey: 'payrollLoanRequestStepTwo-purposeStudies',
    },
    PURPOSE_WEDDING: {
        id: '29',
        icon: 'loan-purpose-wedding',
        text: 'contractEasyLoanStepOne-purposeWedding',
        stepThreeTransKey: 'payrollLoanRequestStepThree-purposeWedding',
        payrollLoanRequestTransKey: 'contractLoanSuccess-purposeWedding',
        payrollLoanContractsTransKey: 'contractLoanSuccess-purposeWeddingContracts',
        stepTwoTransKey: 'payrollLoanRequestStepTwo-purposeWedding',
    },
    PURPOSE_OTHER: {
        id: '27',
        icon: 'loan-purpose-others',
        text: 'contractEasyLoanStepOne-purposeOther',
        payrollLoanRequestTransKey: 'contractLoanSuccess-other',
        payrollLoanContractsTransKey: 'contractLoanSuccess-other',
        stepTwoTransKey: 'payrollLoanRequestStepTwo-other',
    }
};

function findPurposeById(id) {
    let result;
    Object.keys(PURPOSES).forEach(purposeKey => {
        const purpose = PURPOSES[purposeKey];
        if (purpose.id === id) {
            result = purpose;
        }
    });

    return result;
}

module.exports = {
    PURPOSES,
    findPurposeById
};
